import { GoogleOAuthProvider } from "@react-oauth/google";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./authConfig";
import Routes from "./routes";
import "./assets/css/app.css";
import "./assets/scss/app.scss";

import "react-toastify/dist/ReactToastify.css";

import { AuthContext, AuthProvider } from "./context/AuthContext";
import { BasicProvider } from "./context/BasicContext";

import Loader from "./components/Loader";
import { useEffect, useState } from "react";
import useKeyboardAdjustments from "./hooks/useKeyboardAdjustments";
function App() {
  useKeyboardAdjustments();

  return (
    // <MsalProvider instance={msalInstance}>
    //   <GoogleOAuthProvider clientId={window.GOOGLE_LOGIN_API_KEY}>
    //     <AuthProvider>
    //       <BasicProvider>
    //         <AuthContext.Consumer>{({ loader }) => (loader ? <Loader /> : <Routes />)}</AuthContext.Consumer>
    //       </BasicProvider>
    //     </AuthProvider>
    //   </GoogleOAuthProvider>
    // </MsalProvider>
    <div className=' flex flex-1 h-[100vh] items-center justify-center w-full text-[21px] font-semibold leading-[28px] text-primary'></div>
  );
}

export default App;
